export default "__VITE_ASSET__386cf33d__"